module.exports = __webpack_public_path__ + "40fee0d3e5659bd820974e143fb3f3e1.png";